module.exports = __webpack_public_path__ + "img/rimtranslate.5481ceb3.jpg";